import { useQuery } from 'react-query';
import { userProfileService } from 'services/auth';

import useWindowSize from 'hooks/use-windowSize';

import DesktopSettings from 'components/pages/settings/DesktopSettings';
import DesktopAccount from 'components/pages/settings/account/DesktopAccount';
import MobileSettings from 'components/pages/settings/MobileSettings';

import BackButton from '@core/components/backbutton/BackButton';

import { isUserLoggedIn, getAccessToken } from 'utils/authentication';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import classes from './index.module.scss';

const Settings = () => {
	const { data } = useQuery(
		['user-profile', isUserLoggedIn(), getAccessToken()],
		userProfileService,
		{
			cacheTime: 20 * 60 * 1000,
			staleTime: 20 * 60 * 1000
		}
	);
	const { mobileDevice } = useWindowSize();
	const seoProps = generateSeoProps({
		title: 'Pharmuni | Settings',
		canonical: 'settings'
	});
	return (
		<>
			<NextSeo {...seoProps} />
			<div className="container mt-5 col-12">				
				<>
					{mobileDevice ? (
						<MobileSettings hasPasswordSection={!data?.data.is_oauth} />
					) : (
						// <DesktopSettings hasPasswordSection={!data?.data.is_oauth} />
						<DesktopAccount />
					)}
				</>
			</div>
		</>
	);
};

export default Settings;
